import { render, staticRenderFns } from "./LegacyServiceBookDashboard.vue?vue&type=template&id=5b4c10ad&scoped=true"
import script from "./LegacyServiceBookDashboard.vue?vue&type=script&lang=js"
export * from "./LegacyServiceBookDashboard.vue?vue&type=script&lang=js"
import style0 from "./LegacyServiceBookDashboard.vue?vue&type=style&index=0&id=5b4c10ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c10ad",
  null
  
)

export default component.exports